@if (src) {
	<img [src]="src" (error)="onError()" class="avatar" [ngClass]="size" alt="avatar" />
} @else {
	<div class="avatar avatar-fallback" [ngClass]="size" aria-hidden="true">{{ initial }}</div>
}
